import { adminHttpClient } from '../commons/adminHttpClient'

export interface EmployeeSignupState {
  personalEmail: string | null
  phoneNumber: string | null
  familyStatusId: number | null
}

const employeeSignupStateApi = (): Promise<any> => {
  return adminHttpClient.get('/EESignup/Wizard/State')
}

export default employeeSignupStateApi
